import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import BorderButton from './light-weight/BorderButton';

const useStyles = makeStyles(() => ({
  root: {
    width: 32,
    minWidth: 32,
    color: '#FF9B15',
    borderColor: '#FF9B15',

    '& .action-button-svg': {
      '&--terminate': {
        width: 20,
        height: 20,
      },
    },
  },
}));

const ActionButtonTerminate = ({ className = '', ...restProps }) => {
  const classes = useStyles();

  return (
    <BorderButton className={`${classes.root} ${className}`} {...restProps}>
      <PowerSettingsNewIcon className="action-button-svg action-button-svg--terminate" />
    </BorderButton>
  );
};

export default ActionButtonTerminate;
